// Consumable effect_kind → visual metadata (colour, kind tag, human-readable description).
const EFFECT_KIND_META = {
  heal_pct:      { color: '#4ade80', kind: 'heal',    label: 'Restores HP' },
  regen:         { color: '#22c55e', kind: 'heal',    label: 'HP regen over time' },
  stat:          { color: '#f59e0b', kind: 'buff',    label: 'Stat boost' },
  initiative:    { color: '#38bdf8', kind: 'buff',    label: 'Strikes first' },
  cleanse:       { color: '#a78bfa', kind: 'cleanse', label: 'Removes debuffs' },
  xp_multiplier: { color: '#facc15', kind: 'buff',    label: 'XP multiplier' },
  chaos:         { color: '#f472b6', kind: 'chaos',   label: 'Chaos surge' },
  crit_mult:     { color: '#fb7185', kind: 'damage',  label: 'Crit damage boost' },
};

export function effectKindMeta(item) {
  const base = EFFECT_KIND_META[item?.effect_kind] || { color: '#22d3ee', kind: 'buff', label: 'Consumable effect' };
  const detail = item?.effect_stat
    ? ` +${item.effect_value || 0} ${item.effect_stat}`
    : (item?.effect_value ? ` +${item.effect_value}` : '');
  return { color: base.color, kind: base.kind, description: `${base.label}${detail}`.trim() };
}
